const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

export const api = {
  get: async (url, token = null) => {
    const headers = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const res = await fetch(`${API}${url}`, { headers });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },
  post: async (url, data, token = null) => {
    const headers = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const res = await fetch(`${API}${url}`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },
  put: async (url, data, token = null) => {
    const headers = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const res = await fetch(`${API}${url}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },
  delete: async (url, token = null) => {
    const headers = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    const res = await fetch(`${API}${url}`, { method: "DELETE", headers });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value || 0);
};

// Normaliza un teléfono a formato E.164 español sin "+" (ej: "34612345678"),
// sea cual sea el formato en que se haya guardado (con o sin +34/0034,
// espacios, guiones). Antes cada pantalla armaba el link de WhatsApp a mano
// y varias duplicaban el prefijo (wa.me/3434612345678, que WhatsApp no
// resuelve al contacto correcto) o no lo agregaban (wa.me/612345678, mismo
// problema). Devuelve null si no queda un móvil español de 9 dígitos.
export const normalizarTelefonoEspana = (telefono) => {
  let limpio = (telefono || "").replace(/\D/g, "");
  if (limpio.startsWith("0034")) limpio = limpio.slice(4);
  else if (limpio.startsWith("34") && limpio.length > 9) limpio = limpio.slice(2);
  if (!limpio || limpio.length !== 9) return null;
  return `34${limpio}`;
};

// Abre WhatsApp Web/app con un mensaje prearmado a un teléfono español ya
// normalizado. Si el teléfono no es válido, avisa y no abre nada — mejor
// eso que un link roto en silencio.
export const abrirWhatsApp = (telefono, mensaje) => {
  const numero = normalizarTelefonoEspana(telefono);
  if (!numero) {
    alert("⚠️ El teléfono no es válido — tiene que tener 9 dígitos.");
    return false;
  }
  window.open(`https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`, "_blank");
  return true;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
};
